import { useAuth } from 'providers';
import { Route, RouteProps } from 'react-router-dom';
import Login from 'views/Login';

const PrivateRoute = ({ ...props }: RouteProps) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Route {...props} /> : <Login />;
};

export default PrivateRoute;
